import { mediaUrl } from '@/lib/api';

/**
 * Responsive image helpers. Uploaded photos (/api/uploads/...) can be served resized and as WebP by the backend
 * (`?w=800&fmt=webp`), so we build a srcset from those variants. External URLs are passed through untouched.
 */
export const PHOTO_WIDTHS = [480, 800, 1280, 1600];
export const THUMB_WIDTHS = [320, 480, 800];

export const isUpload = (url = '') => typeof url === 'string' && url.startsWith('/api/uploads/') && /\.(jpe?g|png|webp)(\?|$)/i.test(url);

export const variantUrl = (url, w, fmt = 'webp') => {
  if (!isUpload(url)) return mediaUrl(url);
  const sep = url.includes('?') ? '&' : '?';
  return mediaUrl(`${url}${sep}w=${w}&fmt=${fmt}`);
};

export const srcSetFor = (url, widths = PHOTO_WIDTHS) => (isUpload(url) ? widths.map((w) => `${variantUrl(url, w)} ${w}w`).join(', ') : undefined);

/** Props to spread on an <img>: src (original fallback), srcSet (WebP variants) and sizes. */
export const imgProps = (url, { widths = PHOTO_WIDTHS, sizes = '100vw' } = {}) => {
  const srcSet = srcSetFor(url, widths);
  return srcSet ? { src: mediaUrl(url), srcSet, sizes } : { src: mediaUrl(url) };
};

/** Decorative images (the visible text already describes them) get an empty alt + presentation role. */
export const decorative = { alt: '', role: 'presentation', 'aria-hidden': 'true' };
